import React, { useState } from 'react';

const styleOptions = [
  { value: 'realistic', label: 'Realistic' },
  { value: 'artistic', label: 'Artistic' },
  { value: 'cartoon', label: 'Cartoon' },
  { value: 'anime', label: 'Anime' },
];

const sizeOptions = [
  { value: '512x512', label: '512 x 512' },
  { value: '768x768', label: '768 x 768' },
  { value: '1024x1024', label: '1024 x 1024' },
];

const API_KEY = 'c99c4b9c-b3df-4363-a5f1-26e516352fa0';
const BASE_URL = 'https://cloud.leonardo.ai/api/rest/v1';

function Generate() {
  const [prompt, setPrompt] = useState('');
  const [style, setStyle] = useState(styleOptions[0].value);
  const [size, setSize] = useState(sizeOptions[0].value);
  const [imageUrl, setImageUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const styleMap = {
    realistic: 'LEONARDO',
    artistic: 'LEONARDO_DIFFUSION_XL',
    cartoon: 'LEONARDO_3D_RENDER',
    anime: 'ANIME',
  };

  const sizeMap = {
    '512x512': { width: 512, height: 512 },
    '768x768': { width: 768, height: 768 },
    '1024x1024': { width: 1024, height: 1024 },
  };

  const handleGenerate = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setImageUrl('');
    try {
      // 1. Send generation request
      const genRes = await fetch(`${BASE_URL}/generations`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${API_KEY}`,
        },
        body: JSON.stringify({
          prompt,
          modelId: '1e60896f-3c26-4296-8ecc-53e2afecc132',
          width: sizeMap[size].width,
          height: sizeMap[size].height,
          num_images: 1,
        }),
      });
      const genData = await genRes.json();
      if (!genRes.ok || !genData.sdGenerationJob) throw new Error(genData.error || 'Failed to start generation');
      const generationId = genData.sdGenerationJob.generationId;

      // 2. Poll for result
      let image = null;
      for (let i = 0; i < 20; i++) {
        await new Promise(r => setTimeout(r, 2000));
        const pollRes = await fetch(`${BASE_URL}/generations/${generationId}`, {
          headers: { 'Authorization': `Bearer ${API_KEY}` },
        });
        const pollData = await pollRes.json();
        if (pollData.generations_by_pk && pollData.generations_by_pk.generated_images.length > 0) {
          image = pollData.generations_by_pk.generated_images[0].url;
          break;
        }
      }
      if (!image) throw new Error('Image generation timed out.');
      setImageUrl(image);
    } catch (err) {
      setError(err.message || 'Error generating image.');
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async () => {
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `ai-generated-${Date.now()}.jpg`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  return (
    <div className="max-w-2xl mx-auto">
      <h1 className="text-3xl font-bold mb-8 text-center">Generate AI Image</h1>
      <form onSubmit={handleGenerate} className="bg-gray-800 p-6 rounded-lg space-y-6 mb-8">
        <div>
          <label className="block mb-2 font-semibold">Prompt</label>
          <textarea
            className="w-full p-3 rounded bg-gray-900 text-white border border-gray-700 focus:outline-none focus:border-blue-500"
            rows={3}
            placeholder="Describe your image..."
            value={prompt}
            onChange={e => setPrompt(e.target.value)}
            required
          />
        </div>
        <div className="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0">
          <div className="flex-1">
            <label className="block mb-2 font-semibold">Style</label>
            <select
              className="w-full p-2 rounded bg-gray-900 text-white border border-gray-700 focus:outline-none focus:border-blue-500"
              value={style}
              onChange={e => setStyle(e.target.value)}
            >
              {styleOptions.map(opt => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          </div>
          <div className="flex-1">
            <label className="block mb-2 font-semibold">Size</label>
            <select
              className="w-full p-2 rounded bg-gray-900 text-white border border-gray-700 focus:outline-none focus:border-blue-500"
              value={size}
              onChange={e => setSize(e.target.value)}
            >
              {sizeOptions.map(opt => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          </div>
        </div>
        <button
          type="submit"
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 rounded transition-colors disabled:opacity-50"
          disabled={loading}
        >
          {loading ? 'Generating...' : 'Generate'}
        </button>
        {error && <div className="text-red-500 mt-2 text-center">{error}</div>}
      </form>
      {imageUrl && (
        <div className="bg-gray-800 p-6 rounded-lg text-center">
          <h2 className="text-xl font-semibold mb-4">Generated Image</h2>
          <img
            src={imageUrl}
            alt="Generated AI"
            className="mx-auto rounded shadow-lg"
            style={{ maxWidth: '100%', height: 'auto' }}
          />
          <button
            onClick={handleDownload}
            className="inline-block mt-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded transition-colors"
          >
            Download
          </button>
        </div>
      )}
    </div>
  );
}

export default Generate; 